import { Link, useNavigate } from 'react-router-dom'
import { AuthModal } from '../components/AuthModal'
import { Brand } from '../components/Brand'
import { useAuth } from '../store/auth'

export function Login() {
  const navigate = useNavigate()
  const user = useAuth((s) => s.user)
  const logout = useAuth((s) => s.logout)

  const who = user ? user.displayName ?? (user.handle ? `@${user.handle}` : 'goon') : null

  return (
    <main className="halftone grid min-h-[80vh] place-items-center px-4 py-10">
      <div className="w-full max-w-sm text-center">
        <Brand size="lg" className="justify-center" />

        {user ? (
          <div className="panel panel-cyan mt-6 p-6">
            <h1 className="comic-title comic-title-cyan text-3xl">You're in!</h1>
            <p className="mt-2 text-[#e7e7f2]">
              Signed in as <span className="comic-title text-2xl">{who}</span>
            </p>
            <div className="mt-5 flex flex-col items-stretch gap-3">
              <Link to="/" className="btn-comic text-center">
                Back to game
              </Link>
              <button
                onClick={() => void logout()}
                className="btn-ghost text-lg transition-transform active:translate-y-[1px]"
              >
                Sign out
              </button>
            </div>
          </div>
        ) : (
          <>
            <p className="comic-title mt-4 text-2xl">Sign in to climb the Score Board.</p>
            <p className="mx-auto mt-3 max-w-xs text-sm text-muted">
              Bank your sessions to rank and keep your daily multiplier. Play works signed-out too.
            </p>
            <AuthModal open onClose={() => navigate('/')} />
          </>
        )}
      </div>
    </main>
  )
}
